import ls from 'store2'
const toRoleName = {
  data() {
    return {
      userRole: "",
      spcialuser:-1
    }
  },
  methods: {
    toRoleName(role) {

      switch (role) {
        case 'mobil_user': //美孚普通用户 
          this.userRole = 'm0'
         // this.spcialuser=1
          break;
        case 'mobil_administrator': //管理员 
          this.userRole = 'm1'
         // this.spcialuser=1
          break;
        case 'customer_user': //客户普通用户
          this.userRole = 'c0'
         // this.spcialuser=1
          break;
        case 'customer_administrator': //客户管理员
          this.userRole = 'c1'
         // this.spcialuser=1
          break;
        case 'agency_user': //经销商普通用户
          this.userRole = 'a0'
         // this.spcialuser=1
          break;
        case 'agency_administrator': //经销商管理员
          this.userRole = 'a1'
         // this.spcialuser=1
          break;
        case 'mobil_user_safety_auditor': //安全审计员
          this.userRole = 'm3'
         
          break;
        case 'mobil_user_security_administrator': //安全管理员
          this.userRole = 'm4'
         
          break;

      }
      return this.userRole
    }
  }
}

export default toRoleName